import { Td, Tr } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';

import { ShimmerLoading } from 'src/components/common/loading/ShimmerLoading';

export const ErrorBreakdownLoading = ({
  numRows,
  numColumns,
  className,
}: {
  numRows: number;
  numColumns: number;
  className?: string;
}) => {
  if (numColumns < 1 || numRows < 1) {
    throw new Error('expected to have at least 1 row and 1 column');
  }
  return (
    <>
      {[...Array(numRows).keys()].map((trIdx) => (
        <Tr
          key={trIdx}
          className={classnames('chromatic-ignore mt-1', className)}
        >
          <Td width="40%">
            <ShimmerLoading className="my-2 mr-1 h-6" />
          </Td>
          {[...Array(numColumns - 2).keys()].map((tdIdx) => (
            <Td key={tdIdx}>
              <ShimmerLoading className="my-2 mr-1 h-6" />
            </Td>
          ))}
          {numColumns >= 2 && (
            <Td>
              <ShimmerLoading className="my-2 h-6" />
            </Td>
          )}
        </Tr>
      ))}
    </>
  );
};
